import { useCallback, useState } from 'react';
import Button from '../Controls/ButtonComponent/Button';
import { Checkbox } from '../Controls/Checkbox/Checkbox';
import ModalBackground from '../Controls/Modal/ModalBackground/ModalBackground';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  visible: boolean;
  text: string;
  buttonTitle?: string;
  checkbox?: boolean;
  checkboxState?: boolean;
  checkboxName?: string | number;
  checkBoxLabel?: string | number;
  submit: (checkboxStatus?: boolean) => void;
  textClassName?: string;
  buttonClassName?: string;
  buttonTitleClassName?: string;
}

export const HintModal = (props: IProps) => {
  const [checkBoxStatus, setCheckBoxStatus] = useState<boolean>(props.checkboxState || false);

  const changeStatus = useCallback(() => {
    setCheckBoxStatus(!checkBoxStatus);
  }, [checkBoxStatus]);

  const submit = useCallback(() => {
    props.submit(props.checkbox && checkBoxStatus);
  }, [props.checkbox, checkBoxStatus]);

  if (!props.visible) return null;

  return (
    <div className="hint-modal">
      <div className="hint-modal__wrapper">
        <ModalBackground className="hint-modal__content">
          <p className={`hint-modal__text ${props.textClassName || ''}`}>{localeStore.t(props.text)}</p>
          {props.checkbox ? (
            <Checkbox
              value={checkBoxStatus}
              name={props.checkboxName || 'hintModalCheckbox'}
              className="mt-3"
              label={props.checkBoxLabel}
              onClick={changeStatus}
            />
          ) : null}
          <Button
            title={localeStore.t(props.buttonTitle || 'got_it')}
            onClick={submit}
            stretched
            className={`hint-modal__button ${props.buttonClassName || ''}`}
            titleClassName={props.buttonTitleClassName}
          />
        </ModalBackground>
      </div>
    </div>
  );
};
